export enum RuleOperationKind {
    READ = 0,
    WRITE = 1,
    DELETE = 2,
    UPDATE = 3,
    EXECUTE = 4
}
